/**
 * ServicePropertyListSettings содержит настройки фильтра типа список.
 */
export class ServicePropertyListSettings {
  /**
   * IsExpandable позволяет включить функционал сворачивания элементов
   * списка.
   */
  public IsExpandable: boolean = true

  /**
   * AlreadyVisibleElements задает количество всегда показываемых
   * элементов списка. Все остальные будут сворачиваться по кнопке.
   */
  public AlreadyVisibleElements: number = 3

  /**
   * IsExpanded задает изначальное состояние развернутости списка.
   * Если указать true - список будет развернут.
   */
  public IsExpanded: boolean = false

  /**
   * IsDescriptionEnabled позволяет выводить подпись для элементов фильтра.
   * Подпись есть не для всех элементов. Например, для локаций подпись - это
   * строка с областью и страной.
   */
  public IsDescriptionEnabled: boolean = true

  /**
   * IsSelectAllEnabled позволяет включать отображение кнопки "Выбрать все".
   */
  public IsSelectAllEnabled: boolean = true

  /**
   * Префикс и суффикс значения в списке
   */
  public ListItemPrefix: string = ""
  public ListItemSuffix: string = ""

  /**
   * Заглушка для запрета прямого создания объектов данного типа
   * @private
   */
  private constructor() {
  }

  /**
   * RestoreSettings выполняет восстановление данных объекта настроек
   * Функция выполняет нормализацию значений настроек.
   * Функция дополняет недостающие настройки значениями по умолчанию.
   *
   * @param data
   */
  public static RestoreSettings(data: any): ServicePropertyListSettings {
    let result = new ServicePropertyListSettings();

    if (typeof data === "string") {
      data = JSON.parse(data)
    }

    if (typeof data !== "object") {
      return result;
    }

    Object.keys(result).map((key: keyof ServicePropertyListSettings) => {
      // @ts-ignore
      result[key] = ServicePropertyListSettings.GetCorrectFieldValue(key, data[key])
    })

    return result;
  }

  /**
   * GetCorrectFieldValue выполняет восстановление данных поля из переданного значения настроек.
   * Данный метод так же проводит валидацию значения каждой из настроек поля. Метод возвращает
   * значение по умолчанию, если значение передано не корректно.
   */
  public static GetCorrectFieldValue<T extends keyof ServicePropertyListSettings>(
    field: T,
    data: any,
  ): any {
    let defaults = new ServicePropertyListSettings()

    if (data === undefined) {
      return defaults[field]
    }

    switch (field) {
      case "AlreadyVisibleElements":
        return typeof data === "number" && data >= 1 ? data : defaults[field]
      case "ListItemPrefix":
      case "ListItemSuffix":
        return typeof data === "string" ? data : defaults[field]
      case "IsExpandable":
      case "IsExpanded":
      case "IsDescriptionEnabled":
      case "IsSelectAllEnabled":
        return !!data
    }

    return defaults[field];
  }
}